import { Navigate } from 'react-router-dom';

import { allNavItems, isNavItemVisible } from '@/app/navigation';
import { useAuth } from '@/shared/auth/useAuth';

import { escolherTelaInicial } from './escolherTelaInicial';

/**
 * Tela inicial do perfil (ACE-052 e ACE-053).
 *
 * No OnPoint a raiz e o /redirect-to-home levam a tela inicial do perfil: o ADMIN e
 * o COMERCIAL vao as propostas da seguradora, e a CORRETORA as dela. Aqui o perfil
 * guarda a tela inicial (roles.home_route), a sessao entrega a da pessoa, e o acesso
 * entra por /inicio, que leva ate ela. O item "/" do menu continua sendo o Painel.
 */
export function TelaInicial() {
  const { session, can, hasFeature } = useAuth();
  if (!session) return null;

  // Quem entrou pela assessoria (P-ACE-2) escolhe a corretora antes de tudo: sem ela,
  // a sessao nao enxerga nada.
  if (session.advisor && !session.advisor.acting_broker) {
    return <Navigate to="/assessoria/corretoras" replace />;
  }

  const acesso = { can, hasFeature, brokerScoped: session.broker_scoped === true };
  const visiveis = allNavItems().filter((item) => isNavItemVisible(item, acesso));
  return <Navigate to={escolherTelaInicial(session.home_route, visiveis)} replace />;
}
